export const state = () => ({
	company: {},
	isLoading: false,
})

export const actions = {
	async sendNewPassword({ commit, state }, { data }) {
		commit('setIsLoading', true)

		return await useNuxtApp()
			.$api(`/api/companies/${state.company.id}/update_password/`, {
				method: 'PATCH',
				body: {
					new_password: data.new_password,
					old_password: data.old_password,
				},
			})
			.then((res) => {
				commit('setIsLoading', false)
				return res
			})
	},

	async getCompany({ commit, rootGetters }) {
		commit('setCompany', {})
		return await useNuxtApp()
			.$api(`/api/companies/${rootGetters.companyId}/`)
			.then((res) => {
				commit('setCompany', res)
				return res
			})
			.catch((err) => {
				return err
			})
	},
}

export const mutations = {
	setCompany(state, data) {
		state.company = data
	},
	setCompanyFeatures(state, data) {
		if (state.company?.settings) {
			state.company.settings.features = data
		}
	},

	setIsLoading(state, data) {
		state.isLoading = data
	},
}

export const getters = {
	companyFeatures: (state) => state.company?.settings?.features || {},
}
